import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {WorkUpdateServiceService} from "../work-update-service.service";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LogService} from "../../../../../services/log.service";
import {MatDialog} from "@angular/material/dialog";
import {AddEditWorkUpdateComponent} from "../add-edit-work-update/add-edit-work-update.component";
import {EducationWorkUpdateViewComponent} from "../education-work-update-view/education-work-update-view.component";
import {MatSelectChange} from "@angular/material/select";
import {FormControl} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {CentreOption} from "../../educationObservation/education-observation.model";
import {MatSort} from "@angular/material/sort";
import {EmployeeService} from "../../../../../services/employee.service";
import {CentreService} from "../../../../../services/centre.service";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {FinancialYearService} from "../../../../../services/financial-year.service";
@Component({
  selector: 'app-work-update-list',
  templateUrl: './work-update-list.component.html',
  styleUrls: ['./work-update-list.component.scss']
})
export class WorkUpdateListComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  displayedColumns = ['sr', 'centreName', 'date', 'submittedBy', 'task', 'remarks', 'actions'];
  dataSource = new MatTableDataSource<any>();
  allWorkUpdates: any[] = []; //  Store all original data

  mTeacher: string = 'All';
  selectedCentre: string = 'All';
  SelectCentre = new FormControl('All');

  centres$!: Observable<CentreOption[]>;
  teachers$!: Observable<any[]>;

  isLoading = false;
  userData: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  teacherType: string = 'All';

  startDate = new FormControl<Date | null>(null);
  endDate = new FormControl<Date | null>(null);

  constructor(
    private service: WorkUpdateServiceService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private readonly mEmployeeService: EmployeeService,
    private readonly centreService: CentreService,
    private readonly financialYearService: FinancialYearService,
    private mLogService: LogService
  ) {
    this.teachers$ = this.mEmployeeService.getTeachers();
    this.userData = JSON.parse(localStorage.getItem('userData')!);

    if (this.userData.role == 'Centre') {
      this.centres$ = centreService.getSortedCenterListByRole(this.userData.centreCode);
    } else {
      this.centres$ = centreService.getAllCentres();
    }
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);
    this.loadList();
  }

  loadList() {
    this.service.getAllWorkUpdates().pipe(takeUntil(this._destroyed$)).subscribe(data => {
      this.allWorkUpdates = data; // Store all data
      this.dataSource.data = data; //  Show all initially
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  getCentreNames(row: any) {
    const centres = row?.centre ?? [];
    if (!centres.length) return { first: '', extra: 0 };

    return {
      first: centres[0]?.centreName || '',
      extra: centres.length - 1
    };
  }

  // FIXED: Proper search function for Work Updates
  search() {
    this.isLoading = true;

    const centre = this.SelectCentre.value || 'All';
    const teacher = this.mTeacher || 'All';
    const teacherType = this.teacherType || 'All';

    const from = this.startDate.value
      ? new Date(this.startDate.value.setHours(0, 0, 0, 0))
      : null;

    const to = this.endDate.value
      ? new Date(this.endDate.value.setHours(23, 59, 59, 999))
      : null;

    let filtered = [...this.allWorkUpdates];

    //  Centre filter (array of centres)
    if (centre !== 'All') {
      filtered = filtered.filter(item =>
        (item?.centre ?? []).some((c: any) => c.centreCode === centre)
      );
    }

    // Teacher name filter
    if (teacher !== 'All') {
      filtered = filtered.filter(item => item.submittedBy === teacher);
    }

    // Teacher type filter
    if (teacherType !== 'All') {
      filtered = filtered.filter(item => item.teacherType === teacherType);
    }

    // Date range filter
    if (from && to) {
      filtered = filtered.filter(item => {
        const d = item?.date?.toDate();
        return d >= from && d <= to;
      });
    }

    this.dataSource.data = filtered;

    this.paginator?.firstPage();
    this.isLoading = false;
  }


  onCentreChange(event: MatSelectChange) {
    this.selectedCentre = event.value;
    this.SelectCentre.setValue(event.value);
  }

  // FIXED: Clear all filters
  clearAll() {
    // Reset dropdowns
    this.SelectCentre.setValue('All');
    this.mTeacher = 'All';
    this.selectedCentre = 'All';

    // Reset date picker back to the current financial year (not applied until Search is clicked)
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);

    // Show all data
    this.dataSource.data = this.allWorkUpdates;

    // Reset paginator
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


downloadExcelSheet() {
  if (!this.dataSource?.data?.length) {
    return;
  }

  const exportData = this.dataSource.data.map((row: any, index: number) => ({
    'Sr No': index + 1,
    'Date': row.date?.toDate
      ? row.date.toDate().toLocaleDateString()
      : '',
    'Centre': this.getCentreNames(row)?.first +
      (this.getCentreNames(row)?.extra > 0
        ? ` +${this.getCentreNames(row).extra} more`
        : ''),
    'Teacher': row.submittedBy || '',
    'Task / Activities': row.task || '',
    'Remarks': row.remarks || ''
  }));

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData, {
    cellDates: true
  });

  worksheet['!cols'] = [
    { wch: 6 },
    { wch: 14 },
    { wch: 30 },
    { wch: 20 },
    { wch: 60 },
    { wch: 40 }
  ];

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Education Work Update': worksheet },
    SheetNames: ['Education Work Update']
  };

  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  const blob = new Blob([excelBuffer], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  saveAs(blob, `Education_Work_Update_${new Date().getTime()}.xlsx`);
}

  openViewDialog(row: any) {
    this.dialog.open(EducationWorkUpdateViewComponent, {
      width: '1100px',
      height: '80vh',
      data: row
    });
  }

  delete(id: string) {
    const confirmed = window.confirm('Are you sure you want to delete this work update?');
    if (confirmed) {
      this.service.deleteWorkUpdate(id)
        .then(() => {
          this.snackBar.open('Work update deleted successfully.', 'Close', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['snackbar-success']
          });

          const activity = {
            date: new Date().getTime(),
            section: 'Work Updates',
            action: 'Deleted',
            description: `Work update deleted by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);

          // Reload list after delete
          this.loadList();
        })
        .catch(err => {
          console.error(err);
          this.snackBar.open('Failed to delete work update.', 'Close', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['snackbar-error']
          });
        });
    }
  }

  viewEdit(id: string) {
    this.dialog.open(AddEditWorkUpdateComponent, {
      width: '900px',
      maxHeight: '80vh',
      disableClose: true,
      autoFocus: false,
      data: id
    });
  }

  Add() {
    this.dialog.open(AddEditWorkUpdateComponent, {
      width: '900px',
      maxHeight: '80vh',
      disableClose: true,
      autoFocus: false,
      data: null
    });
  }

  protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
